export default {
    TEMPORARY_SAVE_ORDER_DATA: (state, { order, deliveryFile }) => {
        state.order = order
        state.deliveryFile = deliveryFile
    },
    UPDATE_ORDER_CREATE_PRODUCT_LIST: (state, { product, productTemplate }) => {
        state.order.orderProducts.push(product)
        state.productTemplates.push(productTemplate)
    },
    UPDATE_ORDER_CREATE_PRODUCT_TEMPLATE: (state, { index, product, productTemplate }) => {
        state.order.orderProducts[index] = product
        state.productTemplates[index] = productTemplate
    },
    REMOVE_ORDER_CREATE_PRODUCT_TEMPLATE: (state, index) => {
        state.order.orderProducts.splice(index, 1)
        state.productTemplates.splice(index, 1)
    },
    CLEAR_ORDER_CREATE: (state) => {
        state.order = {}
        state.productTemplates = []
    },
    SET_CANCEL_TOKEN: (state, token) => {
        state.cancelToken = token
    }
}